/**
 * Badge styling, kept out of `Badge.tsx` because that file carries `'use client'`.
 *
 * An enum exported from a client module is a client reference: read from a server component it
 * comes back `undefined`, so `props.badgeStyle || BadgeStyle.default` silently substituted the
 * 10px uppercase style for the intended one on every server-rendered count pill. In a
 * directive-free module the value is real on both sides of the boundary.
 *
 * `Badge.tsx` re-exports both, so the 37 files importing them from there keep working.
 */

export enum BadgeStyle {
    default = 'text-body-10 rounded-16 uppercase px-6 py-2',
    large = 'text-body-bold-12 rounded-16 lowercase px-6 py-1',
    large_xl = 'text-body-12 uppercase rounded-16 px-12 py-8',
    large_xxl = 'text-overline-16 uppercase rounded-16 px-16 py-1',
    large_default_case = 'text-body-bold-14 rounded-16 px-6 py-1',
    frameless = 'text-body-bold-12 text-gray-light/50 rounded-16 lowercase px-6 py-1',
    filter = 'text-body-bold-12 rounded-16 px-8 py-4 leading-[20px]',
    filter12 = 'text-body-bold-12 rounded-16 px-12 py-4',
    /** Filter-sheet chip: square-ish corners instead of the pill shape of `filter`. */
    filter_sheet = 'text-body-bold-12 rounded-4 px-8 py-4 leading-[20px] tracking-regular'
}

export const BADGE_STYLE_DEFAULT_OPACITY: Partial<Record<BadgeStyle, '/20' | '/0'>> = {
    [BadgeStyle.default]: '/20',
    [BadgeStyle.large]: '/20',
    [BadgeStyle.large_default_case]: '/20',
    [BadgeStyle.frameless]: '/0'
};
